import { BASEMAP } from "../../actions/portal/";

export default function(state = null, action) {
  switch (action.type) {
    case BASEMAP:
      return action.payload;
    default:
  }

  return state;
}
